/**
 * Visões do portal (BBF-175): cada pessoa vê as áreas das visões que tem. ADMIN e SUPPORT são a
 * equipe Busifarm e veem tudo. A visão é só de tela; quem barra de verdade é a API.
 */
export const VISOES_DO_PORTAL = {
    FINANCEIRA: 'FINANCEIRA',
    LICENCAS: 'LICENCAS',
    SUPORTE: 'SUPORTE',
    USUARIOS_E_PERFIS: 'USUARIOS_E_PERFIS',
};

const EQUIPE_BUSIFARM = ['ADMIN', 'SUPPORT'];

/** O corpo do `GET /auth/users/me`, com ou sem envelope. */
export const extrairMe = (response) => response?.data?.data ?? response?.data?.valor ?? response?.data ?? null;

export const ehEquipeBusifarm = (me) => EQUIPE_BUSIFARM.includes(me?.specialAccessType);

/**
 * Se a pessoa pode ver a área da visão. Área sem visão fica aberta, como sempre foi. Sem o `/me`,
 * nenhuma área com visão abre.
 */
export const temVisao = (me, visao) => {
    if (!visao) return true;
    if (!me) return false;
    if (ehEquipeBusifarm(me)) return true;
    const visoes = Array.isArray(me.visoesPortal) ? me.visoesPortal : [];
    return me.acessoPortal === true && visoes.includes(visao);
};
